import { ProgressBar as Bar } from '@educaplay/core';
import classes from './ProgressBar.module.scss';

export default function ProgressBar({ value, total }) {

  const progress =  value / total * 100;

  return (
      <Bar className={classes.bar} value={progress} />
  )
}